var NewUserRewardPanel = require("clover/panel/NewUserRewardPanel")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var QzoneBackgroundPanel = xClass("QzoneBackgroundPanel", NewUserRewardPanel, function () {
    return cc.CSLoader.createNode("cocos/qzone_cover_panel1.csb")
})
function getPlatformTitle() {
    return table([1, "name", ""], [1, "title", "礼包"])
}

var resList = [
    "cocos/qzone_cover_panel1_btn.csb",
    "cocos/qzone_cover_panel1.csb",
    "cocos/qzone_cover_racoon_light.csb",
    "cocos/qzone_cover.plist"
]

QzoneBackgroundPanel.asyncCreate = function (onCloseCallback, fail, cancel) {
    function onSuccess() {
        let panel = QzoneBackgroundPanel.create(onCloseCallback)
        panel.popup()
    }
    preloadWithLoading(resList, onSuccess, fail, cancel)
}
QzoneBackgroundPanel.prototype.itemPos = table([1, 2, table(
    [1, 1, table([0, 127 + 65], [0, -347])],
    [1, 2, table([0, 271 + 165], [0, -347])],
)])
QzoneBackgroundPanel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)
    self.setScale(self.getReferenceScale())
    // var title = getPlatformTitle()
    // var titleLabel = NewUserRewardPanel.createMixedTitle(title)
    // var titleLabel = cc.Label.createWithSystemFont("设置空间专属背景", "Arial", 45, 400)
    // titleLabel.setTextColor(cc.color(180, 119, 59, 255))
    // titleLabel._setFontWeight("bold")
    // titleLabel.setAnchorPoint(cc.p(0.5, 0.5))
    // titleLabel.setPosition(275, -130)
    // self.addChild(titleLabel)

    var newReward = MetaManager.getInstance().getSetQzoneBackgroundRewards()

    self.config = newReward
    // self.getChildByName("desc").setVisible(false)
    // self.getChildByName("energybg").setVisible(false)
    let all_size = self.getContentSize()

    var closeBtn = self.getChildByName("close_btn")
    var close = UIGroupButton.create(closeBtn)
    ButtonPushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        self.onClose()
    })
    // var text = cc.Label.createWithSystemFont(getText("panel.text.cover_set_hint"), "Arial", 27, 50)
    // text.setTextColor(cc.color(180, 119, 59, 255))
    // text.setAlignment(cc.TEXT_ALIGNMENT_LEFT)
    // text.setDimensions(420, 100)
    // text.setPosition(all_size.width / 2, -250)
    // text.setAnchorPoint(0.5, 0.5)
    // self.addChild(text)
    var title = self.getChildByName("title")
    title.setString(getText("qzone.background.panel.title"))
    title.setPositionY(title.getPositionY() - 10)
    title.setPositionX(title.getPositionX() - 5)
    // title.setFontSize(28)
    var msg1 = self.getChildByName("msg1")
    msg1.setString(getText("qzone.background.panel.msg1"))
    msg1.setFontSize(26)
    msg1.setPositionY(msg1.getPositionY() - 10)
    var msg2 = self.getChildByName("msg2")
    msg2.setString(getText("qzone.background.panel.msg2"))
    msg2.setFontSize(26)
    msg2.setPositionY(msg2.getPositionY() - 10)
    var rewardCount = $len(newReward)
    var $limit27 = rewardCount
    for (var i = 1; i <= $limit27; i += 1) {
        var config = newReward[i]
        self.createRewardItem(i, config, rewardCount)
    }

    var light1 = self.getChildByName("racoon_light1")
    var timeline1 = cc.CSLoader.createTimeline("cocos/qzone_cover_racoon_light.csb")
    light1.runAction(timeline1)
    timeline1.gotoFrameAndPlay(0, true)

    var light2 = self.getChildByName("racoon_light2")
    var timeline2 = cc.CSLoader.createTimeline("cocos/qzone_cover_racoon_light.csb")
    light2.runAction(timeline2)
    timeline2.gotoFrameAndPlay(0, true)

    var btn = self.getChildByName("btn")
    // var label = btn.getChildByName("label")
    // label.setAnchorPoint(cc.p(0.5, 0.5))
    // label.setPosition(52, -5)
    // // read from strings
    // // label.setString(getText("ShortcutTask.get"))
    // label.setString(getText("知道了"))
    self.getbtn = UIGroupButton.create(btn)
    self.getbtn.setText(getText("qzone.background.panel.btn"))
    PushBounceIdleBubbleAnim.create(self.getbtn)
    self.busy = false
    self.getbtn.on(UIButtonEvent.Click, function () {
        DCAssist.userTrack("cover", "click_btn");
        self.setQzoneBackground()
        self.onClose()
    })
}
QzoneBackgroundPanel.prototype.createRewardItem = function (index, config, rewardCount) {
    var self = this
    var itemId = config.itemId
    var num = config.num
    var [posX, posY] = [self.itemPos[rewardCount][index][1], self.itemPos[rewardCount][index][2]]
    var icon = UIItemBuilder.createProp(itemId, num, 0, true)[0]
    icon.setPosition(posX, posY)
    self.addChild(icon, 5)
    self.rewardItems[index] = icon
}
QzoneBackgroundPanel.prototype.cleanup = function () {
    NewUserRewardPanel.prototype.cleanup.call(this)
}
QzoneBackgroundPanel.prototype.setQzoneBackground = function () {
    var self = this
    //设置空间背景的地址
    var url = "https://h5.qzone.qq.com/bgstore/detail/128331?_wv=2098179&from=adv&page=1&router=detail&coverid=128331&_proxy=1"
    function onFail() {
        Toast.make("进入背景商城失败，请重试！")
    }
    function callback(e) {
        if (!e.detail.hidden) {
            document.removeEventListener("cloverVisibilityChange", callback)
            self.checkCoverRewards()
        }
    }
    document.addEventListener("cloverVisibilityChange", callback)
    GameProxy.getInstance().openUrl(url, null, onFail, null)
}
QzoneBackgroundPanel.prototype.checkCoverRewards = function () {
    var self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    function onFinish(data) {
        var hasFetchCoverRewards = data.data.hasFetchCoverRewards
        var hasSetCover = data.data.hasSetCover
        var HomeScene = require("clover/scene/HomeScene")
        var btn = HomeScene.getInstance().btnLayer.qzoneBackgroundBtn
        if(btn){
            if(hasSetCover) {
                btn.rewardIcon.setVisible(false)
            } else {
                btn.rewardIcon.setVisible(true)
            }
        }
        if (!hasFetchCoverRewards && hasSetCover) {
            var QzoneBackgroundRewardsPanel = require("clover/panel/QzoneBackgroundRewardsPanel")
            var panel = QzoneBackgroundRewardsPanel.asyncCreate(function () {
            }, function(){
                Toast.make("网络出了点问题啦~", 2, function () {
                })
            }, function () {
            })
            DCAssist.userTrack("cover", "cover_setup_success");
        } 
    }
    function onCancel() {
    }
    function onError() {
        cc.log("fail to check qzone bg status")
    }
    var http = CoverInfoHttp.new()
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(META.user)
}

module.exports = QzoneBackgroundPanel